import { ServicesDeliveredBy } from '@components/Summary/ServicesDeliveredBy';
import { noddiAsync, URLKeys } from 'noddi-async';
import { SelectedSalesItemsCar } from 'noddi-types';
import { log } from 'noddi-web';
import { useEffect } from 'react';
import { useCurrentBrand } from '../../../../stores/BrandStore/brandStore';

interface BrandBannerProps {
  selectedSalesItemsCars: SelectedSalesItemsCar[];
  selectedAddressId: number;
}

export const BrandBanner = ({ selectedSalesItemsCars, selectedAddressId }: BrandBannerProps) => {
  const { currentBrand } = useCurrentBrand();

  const { data: bookingCategories, isPending: isBookingCategoriesPending } = noddiAsync.useGet({
    type: URLKeys.getBookingCategoriesForNewBooking,
    input: { addressId: selectedAddressId, brandDomain: currentBrand },
    queryConfig: { enabled: !!selectedAddressId }
  });

  const bookingCategory = selectedSalesItemsCars[0]?.bookingCategoryType;

  const foundCategory = bookingCategories?.find((category) => category.type === bookingCategory);
  useEffect(() => {
    if (bookingCategories && bookingCategory && !foundCategory) {
      log({
        value: 'Booking category missing from loaded catalog',
        severity: 'error',
        extra: { responseBody: { bookingCategory } }
      });
    }
  }, [bookingCategories, bookingCategory, foundCategory]);

  if (isBookingCategoriesPending || !foundCategory) {
    return null;
  }

  const brand = foundCategory?.brand;

  if (!brand || brand?.domain === currentBrand) {
    return null;
  }

  return <ServicesDeliveredBy brandName={brand.name} logoUrl={brand.logo?.url} />;
};
